/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { FunctionComponent, useEffect } from 'react';

import { DeviceModel } from '../../../../core/device';
import { Locale, LocaleKeys } from '../../../../core/locale';
import { NetworkManager } from '../../../../core/network/NetworkManager';
import {
    RootState,
    useTivoDispatch,
    useTivoSelector,
} from '../../../../core/tivo/tivo-redux-wrapper';
import { showWhisper } from '../../../../store/whisper/whisper.reducer';
import { AntiburnOsd } from '../../../common';
import { NoNetworkOverlay } from '../../../NoNetworkOverlay';
import { Whisper } from '../../../Whisper';
import { WhisperTypes } from '../../../Whisper/WhisperTypes';
import { FilteredGuideFooter } from '../FilteredGuideFooter';

import './EmptyFilteredGuide.scss';

const EmptyFilteredGuide: FunctionComponent = (): JSX.Element => {
    const { isActive: isAntiBurnOsdActive } = useTivoSelector(
        (state: RootState) => state.antiburnOsd,
    );

    const noShowsSelectedText = Locale.getString(LocaleKeys.EMPTY_FILTERED_GUIDE_NO_SHOWS_MESSAGE);
    const selectDifferentChannelListText = Locale.getString(
        LocaleKeys.EMPTY_FILTERED_GUIDE_ACTION_CHANGE_FILTERS,
    ).replace('BUTTON_NAME', DeviceModel.isWebOsPlatform() ? 'OK' : 'SELECT');

    const dispatch = useTivoDispatch();

    useEffect(() => {
        if (NetworkManager.isNetworkDisconnected()) {
            dispatch(
                showWhisper({
                    message: NetworkManager.getNetworkDisconnectedMessage(),
                    iconType: WhisperTypes.INFO,
                }),
            );
        }
    }, []);

    return (
        <div className="empty-filtered-guide-container">
            <div className="empty-guide-message">
                <p className="empty-guide-paragraph">{noShowsSelectedText}</p>
                <p className="empty-guide-paragraph">{selectDifferentChannelListText}</p>
            </div>
            <FilteredGuideFooter
                rightSideText={Locale.getString(LocaleKeys.GUIDE_SELECT_PRESS_AND_HOLD_MESSAGE)}
            />
            {isAntiBurnOsdActive && <AntiburnOsd />}
            <NoNetworkOverlay />
            <Whisper message="" />
        </div>
    );
};

export default EmptyFilteredGuide;
